const { conf } = require('./configService');

// TODO rename to hostnameService
const domainService = {
  isLocalDrupalDevDomain: hostname =>
    hostname.endsWith(conf.localDrupalDevDomain),

  isLocalGatsbyDevDomain: hostname =>
    ['localhost', '[::1]', '0.0.0.0'].includes(hostname) || // [::1] is the IPv6 localhost address.
    hostname.startsWith('192.168') ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),

  isLocalDomain: hostname =>
    domainService.isLocalGatsbyDevDomain(hostname) ||
    domainService.isLocalDrupalDevDomain(hostname),

  getDrupalDomain: hostname => {
    if (conf.canonicalDomain === hostname) {
      return hostname;
    }
    const regex = /^.*(stage-|prod-|dev-|origin-).*$'/;
    const results = regex.exec(hostname);

    if (!results) {
      return hostname;
    }
    let environment = results[1].replace('-', '');
    if (environment === 'prod') {
      environment = 'origin';
    }
    let mode = '';
    if (hostname.indexOf('deploy-') !== -1) {
      mode = 'deploy-';
    } else if (environment === 'origin') {
      return conf.canonicalDomain;
    }
    return `cms-${mode}${environment}-${conf.siteCountryCode}.ngeo.com`;
  },

  isRunningOnCMS: () => {
    if (typeof window === 'object') {
      return (
        window.location.hostname.indexOf('cms-') !== -1 ||
        domainService.isLocalDrupalDevDomain(window.location.hostname)
      );
    }
    return false;
  },

  removeDomain: href => href.replace(/.*\/\/[^/]*/, '')
};

module.exports = { domainService };
